import { render } from "./mini.vue?vue&type=template&id=580b618a&scoped=true"
import script from "./mini.vue?vue&type=script&lang=js"
export * from "./mini.vue?vue&type=script&lang=js"

import "./mini.vue?vue&type=style&index=0&id=580b618a&lang=scss&scoped=true"

import exportComponent from "/www/publicHouse/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-580b618a"]])

export default __exports__